/**
 * 获取分享、收藏、加入购物车赠送的积分
 */
export default function shareRewardTip(type, data) {
  let tip = ''
  if (data && (data.pointsReward || data.experiencesReward)) {
    if (data.pointsReward) {
      tip += data.pointsReward + '积分'
    }
    if (data.experiencesReward) {
      if (data.pointsReward) {
        tip += '+'
      }
      tip += data.experiencesReward + '经验值'
    }
    tip =
      type +
      '成功，+' +
      tip +
      '<span class="drop-gold-effect"><i></i><i></i><i></i><i></i><i></i><i></i><em class="box"></em></span>'
  }
  return tip ? `<span style="display: flex;align-items: center;white-space: nowrap;">${tip}</span>` : ''
}
